import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  CollapseBlock,
  MainTitle,
  Spinner,
} from '../../../../common/index.jsx';
import {
  useResetPasswordMutation,
  useResetPasswordSubmitMutation,
  useValidateTokenMutation,
} from '../../../../../redux/services/passwordReset.jsx';
import { Alert, Form as AntdForm } from 'antd';
import ForgottenPasswordForm from './ForgottenPasswordForm.jsx';
import { useToastMessages } from '../../../../../hooks/useToastMessages.jsx';

const ForgottenPasswordPage = ({ mode }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = AntdForm.useForm();
  const { token } = useParams();

  const { successMessage } = useToastMessages();

  const isEmail = mode === 'email';

  const [resetPassword, { isSuccess: resetSuccess }] =
    useResetPasswordMutation();
  const [
    resetPasswordSubmit,
    {
      isSuccess: resetSubmitSuccess,
      data: resetSubmitResponse,
    },
  ] =
    useResetPasswordSubmitMutation();
  const [validateToken, { data: tokenValid, isLoading }] =
    useValidateTokenMutation();

  const pageTitle = isEmail
    ? t('Obnovenie zabudnutého hesla')
    : t('Nastavenie nového hesla');

  useEffect(() => {
    document.title = pageTitle;
  }, []); // Runs on mount

  useEffect(() => {
    if (!isEmail && token) {
      validateToken(token);
    }
  }, [token]);

  useEffect(() => {
    if (resetSuccess) {
      successMessage({
        message: t(
          'Vaša žiadosť o odkaz na obnovenie hesla bola úspešne odoslaná.',
        ),
      });
      navigate('/');
    }
  }, [resetSuccess]);

  const onSubmit = (values) => {
    if (isEmail) {
      resetPassword(values);
    } else {
      resetPasswordSubmit({ ...values, token });
    }
  };

  if (isLoading) {
    return <Spinner />;
  }

  if (!tokenValid && !isEmail) {
    return (
      <>
        <MainTitle title={pageTitle} />
        <div style={{ margin: '10px' }}>
          <Alert
            title={t('Neplatný token')}
            description={
              <>
                {t('Token je neplatný alebo už vypršal. Požiadajte o ')}
                <Link to="/zabudnute-heslo">
                  {t('nový odkaz na zmenu hesla')}
                </Link>
                .
              </>
            }
            type="error"
            showIcon
          />
        </div>
      </>
    );
  } else {
    return (
      <>
        <MainTitle title={pageTitle} />
        <div style={{ margin: '10px' }}>
          <CollapseBlock>
            {!isEmail && resetSubmitSuccess ? (
              <Alert
                title={
                  resetSubmitResponse?.message ||
                  t('Heslo bolo úspešne zmenené.')
                }
                description={
                  <>
                    {t('Môžete pokračovať na ')}
                    <Link to="/login">{t('prihlásenie')}</Link>
                    {t(', alebo prejsť na ')}
                    <Link to="/fri-edu">{t('FRI.Edu kurzy')}</Link>
                    {t(' alebo na stránku s akciami ')}
                    <Link to="/fri-open">{t('FRI.open')}</Link>
                    .
                  </>
                }
                type="success"
                showIcon
              />
            ) : (
              <ForgottenPasswordForm
                isEmail={isEmail}
                onSubmit={onSubmit}
                form={form}
              />
            )}
          </CollapseBlock>
        </div>
      </>
    );
  }
};
export default ForgottenPasswordPage;
